import {
  formatApplicationDeadlineDate,
  validateScholarshipDetailProps,
} from './scholarshipDetailPage'
export { validateScholarshipDetailProps, formatApplicationDeadlineDate }
